module.exports = __webpack_public_path__ + "static/media/carnewicon.e90a0cef.svg";